import React, { useRef, useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';

import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Tabs, Tab, Box, Grid, Typography, Stack, Button, FormControl, InputLabel, Select, MenuItem, OutlinedInput, Checkbox, ListItemText } from '@mui/material';

import { useSnackbar } from '../SnackBar';
import { useProgressBar } from '../ProgressBar';
import { useBranchContext } from '../../components/Context/BranchContext';

import { GoogleMap, LoadScript, Autocomplete, useJsApiLoader, Marker } from "@react-google-maps/api";
import { styled } from '@mui/material/styles';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import Chip from '@mui/material/Chip';
import { usePartnerContext } from '../../components/Context/PartnerContext';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, List, ListItem } from '@mui/material';
import countriesData from '../../countries.json';



const libraries = ["places"];

const BranchEditData = ({ }) => {

    const CustomTextField = styled(TextField)({ '& .MuiInputBase-input': { padding: '4px 0 5px !important', }, });
    const { checkEmailExistance } = usePartnerContext();

    const { showSnackbar } = useSnackbar();
    const { showProgress } = useProgressBar();
    const [serviceCategories, setServiceCategories] = useState([]); // Options from API

    const [selectedCategories, setSelectedCategories] = useState([]);
    const { FetchServiceCategory, AddBranches, category, UpdateBranches, loadBranch } = useBranchContext(); // Use your context function

    const [location, setLocation] = useState("");
    const didFetch = useRef(false);
    const [coordinates, setCoordinates] = useState({ lat: null, lng: null });
    const autocompleteRef = React.useRef(null);
    const [showMap, setShowMap] = useState(false);
    const [locationDetails, setLocationDetails] = useState(null);

    const [markerPosition, setMarkerPosition] = useState(null);

    const { id, edit } = useParams();


    // Refs for each input field
    const nameRef = useRef(null);
    const streetRef = useRef(null);
    const buildingRef = useRef(null);
    const neighborhoodRef = useRef(null);
    const cityRef = useRef(null);
    const stateRef = useRef(null);
    const zipRef = useRef(null);
    const countryRef = useRef(null);
    const latitudeRef = useRef(null);
    const longitudeRef = useRef(null);
    const aboutRef = useRef(null);
    const phoneRef = useRef(null);
    const emailRef = useRef(null);

    const [latitude, setlatitude] = useState("");
    const [longitude, setlongitude] = useState("");

    const mondayOpenRef = useRef(null);
    const mondayCloseRef = useRef(null);
    const tuesdayOpenRef = useRef(null);
    const tuesdayCloseRef = useRef(null);
    const wednesdayOpenRef = useRef(null);
    const wednesdayCloseRef = useRef(null);
    const thursdayOpenRef = useRef(null);
    const thursdayCloseRef = useRef(null);
    const fridayOpenRef = useRef(null);
    const fridayCloseRef = useRef(null);
    const saturdayOpenRef = useRef(null);
    const saturdayCloseRef = useRef(null);
    const sundayOpenRef = useRef(null);
    const sundayCloseRef = useRef(null);
    const [categoryName, setCategoryName] = React.useState([]);
    const [selectedcategories, setCategory] = React.useState([]);
    const[selectedCountry,setSelectedCountry]=useState('');
    const navigate = useNavigate()
    const [branchData, setBranchDetails] = useState({
        id: 0, // Replace with actual values
        name: "",
        streetName: "",
        buildingNumber: "",
        neighborhood: "",
        city: "",
        state: "",
        zipCode: "",
        country: "",
        latitude: "",
        longitude: "",
        aboutUs: "",
        phone: "",
        email: "",
        mondayOpen: "",
        mondayClose: "",
        tuesdayOpen: "",
        tuesdayClose: "",
        wednesdayOpen: "",
        wednesdayClose: "",
        thursdayOpen: "",
        thursdayClose: "",
        fridayOpen: "",
        fridayClose: "",
        saturdayOpen: "",
        saturdayClose: "",
        sundayOpen: "",
        sundayClose: "",
        serviceCategory: [""]
    });
    const [files, setFiles] = React.useState([]);

    const handleFileChange = (event) => {
       
        const newFiles = Array.from(event.target.files);
        setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    };

    const handleRemoveFile = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };
    const fetchData = async () => {
        try {
            const serviceCategories = await FetchServiceCategory();
            setServiceCategories(serviceCategories);
            if (id) {
                const branch = await loadBranch(id);

                setBranchDetails(branch);
                setlongitude(branch.longitude);
                setlatitude(branch.latitude);
                setCategoryName(branch.category.map(item => item.id));

                setSelectedCategories(branch.serviceCategory || []);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
       
        if (!didFetch.current) {
            fetchData();

            didFetch.current = true;
        }
    });
    useEffect(()=>{

        if(branchData){
            const branchDat=branchData;
            setSelectedCountry(branchDat.country||"");
        }

    },[branchData]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    // Display selected options or placeholder text if none are selected
    const selectedText =
        selectedOptions.length > 0
            ? selectedOptions.join(", ")
            : "Select Options";

    const getLocationDetails = (lat, lng) => {
        const geocoder = new window.google.maps.Geocoder();
        const latlng = { lat, lng };

        geocoder.geocode({ location: latlng }, (results, status) => {
            if (status === "OK" && results[0]) {
                setLocationDetails(results[0].formatted_address); // Set address details
                console.log("Location details:", results[0]);
                results[0].address_components.forEach((component) => {
                    const types = component.types;

                    if (types.includes("locality")) {
                        // City or town
                        setBranchDetails((prevDetails) => ({
                            ...prevDetails,
                            ["city"]: component.long_name,
                        }));

                    } else if (types.includes("administrative_area_level_1")) {
                        // State

                        setBranchDetails((prevDetails) => ({
                            ...prevDetails,
                            ["state"]: component.long_name,
                        }));
                    }
                    else if (types.includes("neighborhood")) {
                        // State

                        setBranchDetails((prevDetails) => ({
                            ...prevDetails,
                            ["neighborhood"]: component.long_name,
                        }));
                    }
                    else if (types.includes("country")) {
                        // Country
                        setBranchDetails((prevDetails) => ({
                            ...prevDetails,
                            ["country"]: component.long_name,
                        }));
                    }
                    else if (types.includes("postal_code")) {

                        setBranchDetails((prevDetails) => ({
                            ...prevDetails,
                            ["zipCode"]: component.long_name,
                        }));
                    }


                });
            } else {
                console.error("Geocode was not successful for the following reason:", status);
            }
        });
    };
    const handlePlaceChanged = () => {
        const place = autocompleteRef.current.getPlace();

        place.address_components.forEach((component) => {
            const types = component.types;
            if (types.includes("locality")) {
                // City or town
                setBranchDetails((prevDetails) => ({
                    ...prevDetails,
                    ["city"]: component.long_name,
                }));

            } else if (types.includes("administrative_area_level_1")) {
                // State

                setBranchDetails((prevDetails) => ({
                    ...prevDetails,
                    ["state"]: component.long_name,
                }));
            } else if (types.includes("country")) {
                // Country
                setBranchDetails((prevDetails) => ({
                    ...prevDetails,
                    ["country"]: component.long_name,
                }));
            }
            else if (types.includes("postal_code")) {

                setBranchDetails((prevDetails) => ({
                    ...prevDetails,
                    ["zipCode"]: component.long_name,
                }));
            }


        });
        if (place.geometry) {
            const isAccurate = place.address_components?.some(component =>
                ["street_number", "route"].includes(component.types[0])
            );
            setBranchDetails((prevDetails) => ({
                ...prevDetails,
                ["streetName"]: place.name,
            }));
            setLocation(place.formatted_address);
            setCoordinates({
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            });
            setShowMap(!isAccurate);  // Show map if location is not accurate
        }
    }
    const flagIcon = {
        url: "https://upload.wikimedia.org/wikipedia/commons/e/e7/Red_flag_icon_with_transparent_background.svg", // Replace with your icon URL
        scaledSize: { width: 40, height: 40 }, // Adjust size as needed
    };
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: "AIzaSyDb7OBVssOD1k211TyVf12U5zH0IdFY9sY",  // Replace with your API key
        libraries,
    });

    const handleInputChange = (e) => {

        if (e.target.name === 'street') {
            setLocation(e.target.value);
        }
        const { name, value } = e.target;
        setBranchDetails((prevDetails) => ({
            ...prevDetails,
            [name]: value,
        }));
    }; const handleTimeChange = (newValue, field) => {
        if (newValue) {
            setBranchDetails((prevState) => ({
                ...prevState,
                [field]: newValue.format("hh:mm A"), // Format the value to "hh:mm A"
            }));
        }
    };
    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setCategoryName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
        const strvalue = value.map(num => num.toString());



        setSelectedCategories(strvalue);
    };

    const [emailFormat, setEmailformat] = useState(false);
    const [phoneFormat, setPhoneFormat] = useState(false);
    const [emailExists, setEmailExists] = useState(null);
    const checkEmail = async () => {
        if (emailRef.current.value != "") {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (emailRegex.test(emailRef.current.value)) {
                setEmailformat(false)
            } else {
                setEmailformat(true)
            }
            const resp = await checkEmailExistance(emailRef.current.value);
            setEmailExists(resp)
        }
    };
    const [phoneNumber, setPhoneNumber] = useState('');
    const [isValid, setIsValid] = useState(null);
    const validatePhoneNumber = (e) => {
        const number = e.target.value.trim();
        const phoneregExp = /^\u002B9665\d{8}$/;
        if (number !== "") {
            if (phoneregExp.test(number)) {
                setIsValid(true);
            } else {
                setIsValid(false);
            }
        }
    }
    const formRef = useRef([])
    const handleClick = () => {
        const formElements = formRef.current.elements;
        for (let element of formElements) {
            if ((element.tagName === 'INPUT' && element.type != 'BUTTON') || element.tagName === 'TEXTAREA'|| element.tagName === 'SELECT') {
                if (element.value == "") {
                    element.style.borderColor = 'red';
                } else {
                    element.style.borderColor = '';
                }
            }
        }
    }
    const emptyFieldCheck = (e) => {
        if (e.target.value == "") {
            e.target.style.borderColor = '';
        } else {
            e.target.style.borderColor = '';
        }
    }

    const handleAddBranch = async () => {
        debugger
        if (nameRef.current.value.trim() === '' || streetRef.current.value.trim() === '' || buildingRef.current.value.trim() === ''
            || buildingRef.current.value.trim() === '' || neighborhoodRef.current.value.trim() === '' || cityRef.current.value.trim() === ''
            || stateRef.current.value.trim() === '' || zipRef.current.value.trim() === '' || countryRef.current.value.trim() === ''
            || aboutRef.current.value.trim() === '' || phoneRef.current.value.trim() === '' || emailRef.current.value.trim() === ''
            || mondayOpenRef.current.value.trim() === ''
            || mondayCloseRef.current.value.trim() === ''
            || tuesdayOpenRef.current.value.trim() === ''
            || tuesdayCloseRef.current.value.trim() === ''
            || wednesdayOpenRef.current.value.trim() === ''
            || wednesdayCloseRef.current.value.trim() === ''
            || thursdayOpenRef.current.value.trim() === ''
            || thursdayCloseRef.current.value.trim() === ''
            || fridayOpenRef.current.value.trim() === ''
            || fridayCloseRef.current.value.trim() === ''
            || saturdayOpenRef.current.value.trim() === ''
            || saturdayCloseRef.current.value.trim() === ''
            || sundayOpenRef.current.value.trim() === ''
            || sundayCloseRef.current.value.trim() === ''
        ) {
            showSnackbar('Fields  cannot be blank', 'error');
            handleClick();
            return;
        }
        if (coordinates.lat != null || coordinates.lng != null) {
            setlatitude(coordinates.lat.toString());
            setlongitude(coordinates.lng.toString());
        }
        showProgress(true);
        await UpdateBranches({

            id: branchData.id, name: nameRef.current.value.trim(), streetName: streetRef.current.value.trim(), buildingNumber: buildingRef.current.value.trim(),
            neighborhood: neighborhoodRef.current.value.trim(), city: cityRef.current.value.trim(), state: stateRef.current.value.trim(), zipCode: zipRef.current.value.trim()
            , country: countryRef.current.value.trim(), latitude: latitude, longitude: longitude, aboutUs: aboutRef.current.value.trim()
            , phone: phoneRef.current.value.trim(), email: emailRef.current.value.trim(),
            mondayOpen: mondayOpenRef.current.value.trim(), mondayClose: mondayCloseRef.current.value.trim(),
            tuesdayOpen: tuesdayOpenRef.current.value.trim(), tuesdayClose: tuesdayCloseRef.current.value.trim(),
            wednesdayOpen: wednesdayOpenRef.current.value.trim(), wednesdayClose: wednesdayCloseRef.current.value.trim(),
            thursdayOpen: thursdayOpenRef.current.value.trim(), thursdayClose: thursdayCloseRef.current.value.trim(),
            fridayOpen: fridayOpenRef.current.value.trim(), fridayClose: fridayCloseRef.current.value.trim(),
            saturdayOpen: saturdayOpenRef.current.value.trim(), saturdayClose: saturdayCloseRef.current.value.trim()
            , sundayOpen: sundayOpenRef.current.value.trim(), sundayClose: sundayCloseRef.current.value.trim(), serviceCategory: selectedCategories.map(String)

        },files);

        showProgress(false);
        showSnackbar('Branch details added successfully', 'success');

        navigate(`/edit-branch/${branchData.id}/false`)


    };
    const handleCustomTimeInput = (event, field) => {
        const input = event.target.value; // Get raw input
        const formattedInput = input.toUpperCase().trim(); // Ensure consistent casing for AM/PM
        const parsedTime = dayjs(formattedInput, "hh:mm A", true); // Strict parsing

        if (parsedTime.isValid()) {
            handleTimeChange(parsedTime, field); // Update state with valid time
        } else {
            // Optionally handle invalid input (e.g., show an error or ignore the input)
            console.warn("Invalid time format:", formattedInput);
        }
    };
    return (

        <main id="main" className="main">
            <div className="pagetitle">
                <h1></h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/branch">Home</a></li>
                        <li className="breadcrumb-item"><a href="/branch">Branch</a></li>

                    </ol>
                </nav>
            </div>
            <section className="section">
                <div className="row">
                    <div className="card">
                        <div className="card-body">
                            <div className="row"> <div className="col-lg-6">

                                <div className="card-body">
                                    <h5 className="card-title">Branch Details</h5>

                                    <form ref={formRef}>
                                        <div className="row mb-3">
                                            <label htmlFor="inputText" className="col-sm-3 col-form-label">Name</label>
                                            <div className="col-sm-8">
                                                <input type="text" className="form-control" name="name" value={branchData.name} onChange={handleInputChange} ref={nameRef} onBlur={(e) => { emptyFieldCheck(e); }} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label htmlFor="inputText" className="col-sm-3 col-form-label">Street</label>
                                            <div className="col-sm-8">
                                                {isLoaded && (
                                                    <Autocomplete
                                                        onLoad={(autocomplete) => (autocompleteRef.current = autocomplete)}
                                                        onPlaceChanged={handlePlaceChanged}
                                                    >

                                                        <input type="text" name="streetName"
                                                            placeholder="Enter a location"
                                                            value={branchData.streetName}
                                                            onChange={handleInputChange} className="form-control" ref={streetRef} onBlur={(e) => { emptyFieldCheck(e); }} />
                                                    </Autocomplete>
                                                )}
                                                {showMap && (
                                                    <GoogleMap
                                                        mapContainerStyle={{ height: "400px", width: "100%" }}
                                                        center={coordinates}
                                                        zoom={15}
                                                        onClick={(e) => {
                                                            const newMarkerPosition = { lat: e.latLng.lat(), lng: e.latLng.lng() };
                                                            setCoordinates(newMarkerPosition); // Set marker position
                                                            setMarkerPosition(newMarkerPosition); // Set marker position
                                                            console.log("Marker set at:", newMarkerPosition); // Log the coordinates
                                                            getLocationDetails(e.latLng.lat(), e.latLng.lng());
                                                        }}
                                                    >
                                                        {markerPosition && (
                                                            <Marker
                                                                position={markerPosition}
                                                                icon={flagIcon} // Custom icon for marker
                                                            />
                                                        )}
                                                    </GoogleMap>
                                                )}


                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label htmlFor="inputText" className="col-sm-3 col-form-label">Building Number</label>
                                            <div className="col-sm-8">
                                                <input type="text" name="buildingNumber" className="form-control" value={branchData.buildingNumber} ref={buildingRef} onChange={handleInputChange} onBlur={(e) => { emptyFieldCheck(e); }} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label htmlFor="inputText" className="col-sm-3 col-form-label">Neighborhood</label>
                                            <div className="col-sm-8">
                                                <input type="text" name="neighborhood" className="form-control" value={branchData.neighborhood} ref={neighborhoodRef} onChange={handleInputChange} onBlur={(e) => { emptyFieldCheck(e); }} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label htmlFor="inputText" className="col-sm-3 col-form-label">City</label>
                                            <div className="col-sm-8">
                                                <input type="text" name="city" className="form-control" value={branchData.city} ref={cityRef} onChange={handleInputChange} onBlur={(e) => { emptyFieldCheck(e); }} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label htmlFor="inputText" className="col-sm-3 col-form-label">State</label>
                                            <div className="col-sm-8">
                                                <input className="form-control" name="state" type="text" id="formFile" value={branchData.state} ref={stateRef} onChange={handleInputChange} onBlur={(e) => { emptyFieldCheck(e); }} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label htmlFor="inputText" className="col-sm-3 col-form-label">Zip Code</label>
                                            <div className="col-sm-8">
                                                <input className="form-control" name="zipCode" type="text" id="formFile" value={branchData.zipCode} ref={zipRef} onChange={handleInputChange} onBlur={(e) => { emptyFieldCheck(e); }} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label htmlFor="inputText" className="col-sm-3 col-form-label">Country</label>
                                            <div className="col-sm-8">
                                                {/*<input className="form-control" name="country" type="text" id="formFile" value={branchData.country} ref={countryRef} onChange={handleInputChange} onBlur={(e) => { emptyFieldCheck(e); }} />*/}
                                                <select
                                                        className="form-control" 
                                                        name="country"  
                                                        id="formFile" 
                                                        value={selectedCountry} 
                                                        ref={countryRef} 
                                                        onChange={handleInputChange} 
                                                        onBlur={(e) => { emptyFieldCheck(e); }}
                                                        >
                                                            <option value=""></option>
                                                            {countriesData.map((option,index)=>(<option key={index} value={option.Name}>{option.Name}</option>))}
                                                        </select>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label htmlFor="inputText" className="col-sm-3 col-form-label">Email</label>
                                            <div className="col-sm-8">
                                                <input className="form-control" name="email" type="email" id="formFile" value={branchData.email} ref={emailRef} onChange={handleInputChange} onBlur={(e) => { checkEmail(); emptyFieldCheck(e); }} style={{ borderColor:(emailExists === true || emailFormat === true)?'red':''}}/>
                                                {emailExists === true && (
                                                    <div className="form-text text-danger">
                                                        {emailExists === true ? "Email already exists" : "Email is available"}
                                                    </div>)}
                                                {emailFormat === true && (
                                                    <div className="form-text text-danger">
                                                        {emailFormat === true ? "Invalied Email format" : ""}
                                                    </div>)

                                                }
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label htmlFor="inputNumber" className="col-sm-3 col-form-label">Phone</label>
                                            <div className="col-sm-8">
                                                <input className="form-control" name="phone" type="text" id="formFile" value={branchData.phone} ref={phoneRef} onChange={handleInputChange} onBlur={(e) => {
                                                    setPhoneNumber(e.target.value);
                                                    validatePhoneNumber(e);
                                                    emptyFieldCheck(e);
                                                }}
                                                    style={{ borderColor:(isValid === false)?'red':''}}
                                                />
                                                {isValid !== null && (<div className="form-text text-danger">{isValid === false ? "Invalid phone number. Please check the format." : ""}</div>)}
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label htmlFor="inputText" className="col-sm-3 col-form-label">About</label>
                                            <div className="col-sm-8">
                                                <textarea type="text" name="aboutUs" className="form-control" value={branchData.aboutUs} ref={aboutRef} onChange={handleInputChange} onBlur={(e) => { emptyFieldCheck(e); }} />
                                            </div>
                                        </div>


                                        <div className="row mb-3">
                                            <label htmlFor="inputColor" className="col-sm-3 col-form-label">Service Category</label>
                                            <div className="col-sm-8">
                                                <div className="col-sm-10">

                                                    <FormControl fullWidth sx={{ width: '300px' }}>
                                                        <Select
                                                            labelId="demo-multiple-checkbox-label"
                                                            id="demo-multiple-checkbox"
                                                            multiple
                                                            value={categoryName}
                                                            onChange={handleChange}


                                                            renderValue={(selected) => (
                                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                    {selected.map((value) => {
                                                                        // Find the name corresponding to the selected ID

                                                                        const selectedItem = category.find(item => item.serviceCategoryId === value);
                                                                        return (
                                                                            <Chip
                                                                                key={value}
                                                                                label={selectedItem?.serviceCategoryName}

                                                                            />
                                                                        );
                                                                    })}
                                                                </Box>
                                                            )}

                                                            sx={{
                                                                width: "300px",           // Adjust width as needed
                                                                // Rounded corners
                                                                "& .MuiOutlinedInput-root": {

                                                                },
                                                                "& .MuiSelect-select": {
                                                                    padding: "8px 12px",     // Adjust padding
                                                                },
                                                            }}
                                                        >
                                                            {category.map((value) => (
                                                                <MenuItem key={categoryName.serviceCategoryName} value={value.serviceCategoryId}>
                                                                    <Checkbox checked={categoryName.includes(value.serviceCategoryId)} />
                                                                    <ListItemText primary={value.serviceCategoryName} />
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>






                                                </div>              </div>                                        </div>
                                        <div className="row mb-3">
                                            <label className="col-sm-3 col-form-label"></label>
                                            <div className="col-sm-8">
                                                <button type="button" className="btn btn-primary" onClick={handleAddBranch}>Save</button>
                                            </div>
                                        </div>

                                    </form>
                                </div>


                            </div> <div className="col-lg-6">


                                    <div className="card-body">
                                        <h5 className="card-title">Branch Operational Hours</h5>
                                        <Grid item xs={12} sm={6}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Monday Open"
                                                                    inputRef={mondayOpenRef}
                                                                    value={dayjs(branchData.mondayOpen.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'mondayOpen')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Monday Close"
                                                                    inputRef={mondayCloseRef}
                                                                    value={dayjs(branchData.mondayClose.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'mondayClose')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Tuesday Open"
                                                                    inputRef={tuesdayOpenRef}
                                                                    value={dayjs(branchData.tuesdayOpen.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'tuesdayOpen')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Tuesday Close"
                                                                    inputRef={tuesdayCloseRef}
                                                                    value={dayjs(branchData.tuesdayClose.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'tuesdayClose')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Wednesday Open"
                                                                    inputRef={wednesdayOpenRef}
                                                                    value={dayjs(branchData.wednesdayOpen.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'wednesdayOpen')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Wednesday Close"
                                                                    inputRef={wednesdayCloseRef}
                                                                    value={dayjs(branchData.wednesdayClose.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'wednesdayClose')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Thursday Open"
                                                                    inputRef={thursdayOpenRef}
                                                                    value={dayjs(branchData.thursdayOpen.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'thursdayOpen')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Thursday Close"
                                                                    inputRef={thursdayCloseRef}
                                                                    value={dayjs(branchData.thursdayClose.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'thursdayClose')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Friday Open"
                                                                    inputRef={fridayOpenRef}
                                                                    value={dayjs(branchData.fridayOpen.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'fridayOpen')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Friday Close"
                                                                    inputRef={fridayCloseRef}
                                                                    value={dayjs(branchData.fridayClose.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'fridayClose')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Saturday Open"
                                                                    inputRef={saturdayOpenRef}
                                                                    value={dayjs(branchData.saturdayOpen.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'saturdayOpen')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Saturday Close"
                                                                    inputRef={saturdayCloseRef}
                                                                    value={dayjs(branchData.saturdayClose.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'saturdayClose')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Sunday Open"
                                                                    inputRef={sundayOpenRef}
                                                                    value={dayjs(branchData.sundayOpen.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'sundayOpen')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <TimePicker
                                                                    label="Sunday Close"
                                                                    inputRef={sundayCloseRef}
                                                                    value={dayjs(branchData.saturdayClose.toString(), "hh:mm A")}
                                                                    onChange={(newValue) => handleTimeChange(newValue, 'saturdayClose')}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </LocalizationProvider>
                                        </Grid>
                                        <div style={{ marginTop: '20px', display: 'flex', alignItems: 'center' }}>
                                            {/* Attach Icon Aligned to the Left */}
                                            <label htmlFor="file-input" style={{ marginRight: '10px' }}>
                                                <IconButton color="primary" component="span" style={{ color: '#02176D', marginLeft: '-16px' }}>
                                                    <AttachFileIcon style={{ fontSize: '25px' }} />
                                                </IconButton>
                                            </label>
                                            <input
                                                type="file"
                                                multiple
                                                style={{ display: 'none' }}
                                                id="file-input"
                                                onChange={handleFileChange}
                                            />
                                            {/* Text Next to Icon */}
                                            <span style={{ fontSize: '13px', fontWeight: 'bold' }}>Attach Branch Photos</span>
                                        </div>
                                        {/* List of Attached Files */}
                                        <List>
                                            {files.map((file, index) => (
                                                <ListItem
                                                    key={index}
                                                    secondaryAction={
                                                        <IconButton edge="end" onClick={() => handleRemoveFile(index)}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    }
                                                >
                                                    {/* Styled Attached Files Name */}
                                                    <ListItemText
                                                        primary={<span style={{ fontWeight: 'bold', color: '#333' }}>{file.name}</span>}
                                                        secondary={`${(file.size / 1024).toFixed(2)} KB`}
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>

                                    </div>                                </div>
                            </div></div>                            </div>


                </div>
            </section>
        </main>

    );
};


export default BranchEditData;
